module.exports = __webpack_public_path__ + "img/Führungseinheit.69ad0450.svg";